export default class IntegrationFieldDefinitionApiModel {
  constructor(rawModel) {
    this.IntegrationCode = rawModel?.IntegrationCode || null
    this.IntegrationDisplayName = rawModel?.IntegrationDisplayName || null
    this.FieldDefinitions =
      rawModel?.FieldDefinitions?.map(x => new FieldDefinitionApiModel(x)) || []
  }
}

class FieldDefinitionApiModel {
  constructor(rawModel) {
    this.IntegrationCode = rawModel?.IntegrationCode || null
    this.ObjectType = rawModel?.ObjectType || null
    this.FieldCode = rawModel?.FieldCode || null
    this.FieldName = rawModel?.FieldName || null
    this.Description = rawModel?.Description || null
    this.Datatype = rawModel?.Datatype || null // [ NotSet, String, Integer, Decimal, Date, Datetime, Time, Boolean ]
    this.MaxOccurs = rawModel?.MaxOccurs || null
    this.Optional = rawModel?.Optional === true ? true : false
    this.MaxLength = rawModel?.MaxLength || null
    this.ValueOptions = rawModel?.ValueOptions || null
  }
}
